import styled from 'styled-components';

const FilterContainer = styled.div`
  margin-left: 17px;
  position: relative;
  text-transform: uppercase;
`;

const FilterLabel = styled.label`
  font: ${props => props.theme.fontWeightBold} 12px/120% ${props => props.theme.fontFamilyBody};
  text-transform: uppercase;
  color: ${props => props.theme.secondaryColor};
`;

const DropdownContainer = styled.div`
  height: 36px;
  border: 1px solid ${props => props.theme.secondaryColor};
  border-radius: 4px;
  background: #F8F9FB;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 8px;

  &.changed {
    border: 1px solid ${props => props.theme.primaryColor};
  }
`;

const OptionsContainer = styled.div`
  border: 1px solid #D7DFE7;
  border-radius: 4px;
  position: absolute;
  margin-top: 6px;
  right: 0;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
  padding: 15px 10px;
  z-index: 2;
`;

const Option = styled.div`
  font: 800 16px/30px ${props => props.theme.fontFamilyBody};
  color: ${props => props.theme.secondaryColor};
  cursor: pointer;
  &.selected {
    color: ${props => props.theme.bodyColor};
  }

  &:hover {
    background: #F8F9FB
  }
`;

const OptionSectionTitle = styled.div`
  font: 800 16px/30px ${props => props.theme.fontFamilyBody};
  color: ${props => props.theme.bodyColor};
  white-space: nowrap;
  margin-bottom: 15px;
`;

export {
  FilterContainer,
  FilterLabel,
  DropdownContainer,
  OptionsContainer,
  Option,
  OptionSectionTitle,
};
